var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('TheHeader',{staticClass:"account-header",attrs:{"scrollY":0}}),_c('activate-plan'),_c('div',{staticClass:"page"},[_vm._t("default")],2),(!_vm.noFooter)?_c('TheFooter',{staticClass:"account-footer"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }